const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작성일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['교육일', '교육 실시 인원(명)', '교육 이수 인원(명)', '작성일', '작성년도']}
      },
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let dateTarget = "created_at";
    let dateBegin = `${new Date().getFullYear()}-01-01`;
    let dateEnd = `${new Date().getFullYear()}-12-31`;
    if (search.year) {
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
    }
    //  검색일
    if (search.date) {
      if (search.date.startDate) dateBegin = search.date.startDate;
      if (search.date.endDate) dateEnd = search.date.endDate;
    }
    conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})


    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },
  getHead: () => {
    return [
      { name: '작성년도', key: 'body.stdInfo.date' },
      { name: "부서", key: "body.stdInfo.field_name" },
      { name: "교육구분", key: "body.education_type.value" },
      { name: "교육일", key: "body.education_date" },
      { name: "교육 실시 인원(명)", key: "" },
      { name: "교육 이수 인원(명)", key: "" },
      { name: "작성일", key: "created_at" }
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.date? func.getContent(value).stdInfo.date.split('-')[0] : '' // 작성년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).education_type.value; // 교육구분
        case 3:
          return func.getContent(value).education_date; // 교육일
        case 4: { // 교육실시인원
          let count = Number(func.getContent(value).대상자수_남) + Number(func.getContent(value).대상자수_여)
          return func.comma(count)
        }
        case 5: { // 교육이수인원
          let count = Number(func.getContent(value).이수자수_남) + Number(func.getContent(value).이수자수_여)
          return func.comma(count)
        }
        case 6:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
